import React, { forwardRef, ForwardRefRenderFunction } from 'react'
import classNames from 'classnames'
import { useTranslate } from '@/utils/translate/translate-client'
import { useGiveawayContext } from '../../context/GiveawayContext'
import { formatReleaseDate } from '../../utils/dateUtils'
import { GiveawayRefundCard } from './GiveawayRefundCard'
import { PresaleChipSelectorCard } from './PresaleChipSelectorCard'

interface Props {
  className?: string
  mobileProductRef?: (node?: Element | null | undefined) => void
}

const TicketPackSection: ForwardRefRenderFunction<HTMLDivElement, Props> = ({ className, mobileProductRef }, ref) => {
  const { t } = useTranslate('tickets')

  const { tickets, entryVariantId, theatricalSlug, theatricalTitle, handleRefundInfoClick, releaseDate } =
    useGiveawayContext()

  if (!tickets || !entryVariantId) {
    return null
  }

  return (
    <div ref={ref} className={classNames('w-full px-4 md:px-12', className)}>
      <div
        ref={mobileProductRef}
        className="mx-auto flex w-full max-w-[408px] flex-col space-y-6 py-16 md:top-0 lg:sticky shortDesktop:static shortDesktop:top-auto"
      >
        {releaseDate && theatricalTitle && (
          <div className="space-y-2">
            <GiveawayRefundCard
              title={t('giveawayRefundGuarantee', 'Showtime Guarantee')}
              description={t(
                'giveawayRefundGuaranteeDescriptionV3',
                '{{projectName}} releases nationwide {{releaseDate}}; if no showtimes appear near you, you can get a full refund. ',
                { projectName: theatricalTitle, releaseDate: formatReleaseDate(releaseDate) },
              )}
              onInfoClick={handleRefundInfoClick}
            />
          </div>
        )}
        <PresaleChipSelectorCard theatricalSlug={theatricalSlug} tickets={tickets} entriesProductId={entryVariantId} />
      </div>
    </div>
  )
}

export default forwardRef(TicketPackSection)
